import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import type { IImage } from '@models/IImage';
import type { ILink } from '@models/ILink';
import type { IMeta } from '@models/IMeta';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly isThreeCards: boolean;
  readonly title: string;
  readonly subtitle?: string;
  readonly cta?: ILink;
  readonly image: IImage;
  readonly tint: boolean;
  readonly index: number;
  readonly meta?: IMeta;
}

const WayfindingCard = ({
  title,
  subtitle,
  cta,
  image,
  tint,
  isThreeCards,
  index,
  meta,
}: Props) => {
  const isMobile = useMediaQuery(1024);
  return (
    <div className="relative overflow-hidden rounded-[10px] bg-grey-600">
      <Image
        image={image}
        imageClasses="h-full w-full object-cover max-md:aspect-square"
        dataTestId={`CT-182-Wayfinding-Cards-${index}-Image`}
        epiEdit={meta?.editHints?.image as string}
      />
      {tint && (
        <div
          aria-hidden="true"
          className="absolute inset-0 z-10 bg-gradient-to-t from-black-100 to-transparent"
        />
      )}
      <div className="absolute bottom-0 left-0 z-20 p-5 text-white lg:p-8">
        {subtitle && (
          <p
            className={classNames(
              isThreeCards && !isMobile ? 'h6' : 'h5',
              'mb-2'
            )}
            data-testid={`CT-182-Wayfinding-Cards-${index}-Subtitle`}
            data-epi-property-name={meta?.editHints?.subtitle}
          >
            {subtitle}
          </p>
        )}
        <h3
          className={classNames(isThreeCards && !isMobile ? 'h3' : 'h2')}
          data-testid={`CT-182-Wayfinding-Cards-${index}-Title`}
          data-epi-property-name={meta?.editHints?.title}
        >
          {title}
        </h3>
        {cta?.name && cta?.url && (
          <div className="mt-4 lg:mt-8">
            <Button
              link={cta}
              dataTestId={`CT-182-Wayfinding-Cards-${index}-CTA`}
              editHint={meta?.editHints?.cta as string}
            >
              {cta.name}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WayfindingCard;
